import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exceptions',
  templateUrl: './exceptions.component.html',
  styleUrls: ['./exceptions.component.css']
})
export class ExceptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
